/**
 * Title and description text shared by the app's head (composables/usePageSeo.ts, useAppHead.ts) and the build-time
 * prerendered heads (build/prerender-heads.ts), so a shared link's preview and the tab title read the same.
 *
 * No imports: the build runs this under Node, outside Vite's app graph.
 */
export var SITE_NAME = 'True Market Insiders';
/** The site-wide description, as in index.html. */
export var DEFAULT_DESCRIPTION = 'Financial trading tools for options trading, sector analysis, and portfolio management';
/** The link-preview image when a page has none of its own (also in index.html and the prerendered heads). */
export var DEFAULT_OG_IMAGE_PATH = '/img/stockmarket.jpg';
/** Search engines cut a description at about this length; longer text is cut at a word instead. */
export var DESCRIPTION_MAX_LENGTH = 160;
var TITLE_SEPARATOR = ' | ';
/** The whole tab title for a page title: 'NVDA | True Market Insiders', or the site name alone. */
export function siteTitle(title) {
    var trimmed = title === null || title === void 0 ? void 0 : title.trim();
    return trimmed && trimmed !== SITE_NAME ? "".concat(trimmed).concat(TITLE_SEPARATOR).concat(SITE_NAME) : SITE_NAME;
}
/**
 * Whitespace collapsed, and no space inside punctuation: 'the  Dow Jones Industrial Average ? Or' reads 'the Dow Jones
 * Industrial Average? Or'. The CMS preview field arrives as plain text with a space where each inline tag (a bold or a
 * link) used to be, so every sentence ending in a link or bold word showed a detached '?' or '.'.
 */
export function tidyTextSpacing(text) {
    return (text !== null && text !== void 0 ? text : '')
        .replace(/\s+/g, ' ')
        .replace(/ ([?!.,;:)\]}”…%])/g, '$1')
        .replace(/([(\[{“]) /g, '$1')
        .trim();
}
/** Plain text as a meta description: spacing tidied, cut at a word boundary with an ellipsis. Empty is undefined. */
export function toMetaDescription(text, maxLength) {
    if (maxLength === void 0) { maxLength = DESCRIPTION_MAX_LENGTH; }
    var collapsed = tidyTextSpacing(text);
    if (!collapsed)
        return undefined;
    if (collapsed.length <= maxLength)
        return collapsed;
    var cut = collapsed.slice(0, maxLength - 1);
    var lastSpace = cut.lastIndexOf(' ');
    // A single very long word is cut mid-word rather than dropped
    return "".concat((lastSpace > maxLength / 2 ? cut.slice(0, lastSpace) : cut).replace(/[\s.,;:!?-]+$/, ''), "\u2026");
}
